import { get } from 'lodash'

export const getCurrentUserEmail = (state) =>
  get(state, 'appState.user.email', 'unknown')

export const getCurrentUserOffset = (state) =>
  state?.appState?.offset ?? 'unknown'

export const getCurrentPaginationConfig = (state, screen) =>
  state?.appState?.screenPaginationPage?.[screen] ?? {}

export const getScreenScrollOffset = (state, screen) =>
  state?.appState?.screenScrollOffset?.[screen] ?? 0

export const getOrgName = (state) =>
  state?.appState?.user?.orgName ?? ''

export const getBannerIsOpen = (state, route) =>
  state?.appState?.banner?.[route]

export const getQueryStringParameters = (state, screen) =>
  state?.appState?.queryStringParameters?.[screen] ?? {}
